import { ColumnData } from './../../base-models/column-data';
import { UserService } from './../../base-services/user.service';
import { ModalContainerService } from './../../base-classes/containers/services/modal-container.service';
import { BaseDataService } from './../../base-services/base-data.service';
import { ActivatedRoute } from '@angular/router';
import { BaseListComponent } from './../../base-classes/base-list-component';
import { BaseEntity } from './../../base-models/base-entity';
import { Component, Input, Output, EventEmitter } from "@angular/core";
import { MakeProvider } from "../abstract-custom-control";
import { TreeviewItem } from 'ngx-treeview';
import { CollectionService } from '../../base-services/collection.service';
import { TranslateService } from '@ngx-translate/core';
import { DefaultButtonsConfig } from '../../base-models/default-buttons-config';

@Component({
    selector: 'yt-default-tree-view',
    templateUrl: './default-tree-view.component.html',
    providers: [MakeProvider(DefaultTreeViewComponent)]
})
export class DefaultTreeViewComponent
//<T extends BaseEntity> extends BaseListComponent<T>
{
    constructor(
        //protected activatedRoute: ActivatedRoute,
        //protected baseDataService: BaseDataService,
        //protected containerService: ModalContainerService<T>,
        //protected userService: UserService,
        //protected notificationService: NotificationsService,
        //protected collectionService: CollectionService,
        protected translateService: TranslateService,
        protected collectionService: CollectionService
    ){
        ///super(activatedRoute, baseDataService, containerService, userService, notificationService, translateService);
    }
    public loading = true;
    config: any;
    //items: TreeviewItem[] = [];
    @Input('Items') set setItems(items){
        if(items)
            this.items = this.collectionService.ConvertToTreeviewItems(items, this.PropertyName, this.TableColumns);
        this.loading = false;
    }
    @Input() PropertyName: string = 'Naziv';
    @Input() Config: any = {};
    @Input() ShowLoader: boolean;
    @Input() ButtonsConfig: DefaultButtonsConfig;
    @Input() TableColumns: ColumnData[];

    @Output() AddItemClicked = new EventEmitter();
    @Output() EditItemClicked = new EventEmitter();
    @Output() DeleteItemClicked = new EventEmitter();
    @Output() ItemSelected = new EventEmitter();

    items: TreeviewItem[] = [];

    ngOnInit(){
        //super.ngOnInit();
        this.config = {
            hasAllCheckBox: false,
            hasFilter: true,
            hasCollapseExpand: false,
            decoupleChildFromParent: true,
            //maxHeight: 500,
            DefaultListButtonsConfig: new DefaultButtonsConfig()
        }
    }

    //OnMainItemsLoaded(){
        //super.OnMainItemsLoaded();
        //this.items = this.collectionService.ConvertToTreeviewItems(this.mainItems, 'Naziv');
    //}

    select(item: TreeviewItem){
        console.log(item);
    }

    AddItem(){
        //this.containerService.AddItem(this.modelData);
        this.AddItemClicked.emit();
    }

    EditItem(ID: number){
        //this.containerService.EditItem(this.modelData, ID);
        this.EditItemClicked.emit({ ID: ID });
    }

    DeleteItem(ID){
        this.DeleteItemClicked.emit(ID);
    }

    SelectItem(ID){
        this.ItemSelected.emit(ID);
    }

}